<script>
    import { Topbar, Hero, Footer } from "./components";
</script>

<div class="App">
    <Topbar />
    <Hero />
    <Footer />
</div>

<style>
    .App {
        min-height: 100vh;
        position: relative;
    }
</style>